import { __assign, __rest } from "tslib";
// DS: C16A, C16B
/** A collapsable, lazy loaded editor specifically configured for comment posting */
import React from 'react';
import AnonymousView from './views/AnonymousView';
import CantPostView from './views/CantPostView';
import EditorView from './views/EditorView';
import CommentBoxSkeleton from '../CommentBoxSkeleton';
/** Our classic CommentBox implementation. */
var CommentBox = React.forwardRef(function (_a, ref) {
    var autoFocus = _a.autoFocus, onPost = _a.onPost, onClose = _a.onClose, footerClassName = _a.footerClassName, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], nc = _a.nc, editorView = _a.editorView, rest = __rest(_a, ["autoFocus", "onPost", "onClose", "footerClassName", 'aria-label', 'aria-labelledby', "nc", "editorView"]);
    return (React.createElement(CommentBoxSkeleton, __assign({ loggedOutView: React.createElement(AnonymousView, null), editorView: editorView || (React.createElement(EditorView, { nc: nc, onPost: onPost, onCancel: onClose, footerClassName: footerClassName, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy })), cantPostView: React.createElement(CantPostView, null), autoFocus: autoFocus, ref: ref }, rest)));
});
CommentBox.displayName = 'CommentBox';
export default CommentBox;
//# sourceMappingURL=CommentBox.js.map